import { gql } from 'apollo-boost';


export const READ_NOTIFICATIONS_QUERY = gql`
query readNotifications {
    readNotifications{
        edges{
            node{
                notificationId
            }
        }
    }
}
`;